export function getBorderRadius(transformer) {
    return Object.freeze({
        none: transformer.borderRadius('0'),
        small: transformer.borderRadius('4px'),
        medium: transformer.borderRadius('16px'),
        fiftyPercent: transformer.borderRadius('50%'),
    });
}
